import { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { IPagination } from "../../../types/pagination";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useContextSite } from "../../../context/Context";
import { IFaturaDTO } from "../../../types/pagamento";
import { Pagamento } from "../../../services/Pagamento";
import { toast } from "react-toastify";

export const useInvoicesSchedule = () => {
  const [pagination, setPagination] = useState<IPagination>({} as IPagination);
  const [numberPage, setNumberPage] = useState(0);
  const isMobile = useMediaQuery({ maxWidth: "640px" });
  const [searchParams] = useSearchParams();
  const [faturas, setFaturas] = useState<IFaturaDTO[]>([] as IFaturaDTO[]);
  const uuidAgendamento = searchParams.get("id");
  const { setIsLoad } = useContextSite();
  const navigate = useNavigate();

  function getFaturas() {
    setIsLoad(true);
    Pagamento.consultarFatura({ uuidAgendamento, size: 5, page: numberPage })
      .then(({ data }) => {
        setFaturas(data.content);
        setPagination({
          actualPage: data.number,
          totalPage: data.totalPages,
          totalRegister: data.totalElements,
        });
      })
      .catch(
        ({
          response: {
            data: { mensagem },
          },
        }) => toast.error(mensagem)
      )
      .finally(() => setIsLoad(false));
  }

  function acessarFatura(fatura: IFaturaDTO) {
    fatura?.pix?.qrcodeText !== null
      ? navigate(`/agendamento/${uuidAgendamento}/fatura`)
      : window.open(`${fatura?.url}.pdf`, "_blank");
  }

  useEffect(() => {
    if (uuidAgendamento) {
      getFaturas();
    }
  }, [numberPage, uuidAgendamento]);

  return { pagination, isMobile, setNumberPage, faturas, acessarFatura };
};
